import { render, staticRenderFns } from "./DetalheProvedorAnaliticoPage.vue?vue&type=template&id=4d03ca6e"
import script from "./DetalheProvedorAnaliticoPage.vue?vue&type=script&lang=js"
export * from "./DetalheProvedorAnaliticoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports